import Vue from 'vue'
import iView from 'iview';
import VueRouter from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Cookies from 'js-cookie';
import { routers, otherRouter, appRouter } from './router';
import login from '@/views/login'
import Util from '@/libs/util';

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: routers
};
// 不需要登录
let not_login = [
  'loginhtml', // 自动分拣
];
export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    Util.title(to.meta.title);
    if (Cookies.get('locking') === '1' && to.name !== 'locking') { // 判断当前是否是锁定状态
        next({
            replace: true,
            name: 'locking'
        });
    } else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
      const hasLoginToken = localStorage.getItem('Authorization') && Cookies.get('Admin-Token')
      if (!hasLoginToken) {
        localStorage.removeItem('Authorization')
      }
      if (!hasLoginToken && not_login.indexOf(to.name) > -1) { // 判断是否已经登录且前往的页面不是登录页
        next();
      } else if (!hasLoginToken && to.name !== 'login') { // 判断是否已经登录且前往的页面不是登录页
        window.localStorage["htttpUrl"] = '/login'
        next({
          name: 'login'
        });
      } else if (hasLoginToken && to.name === 'login') { // 判断是否已经登录且前往的是登录页
        Util.title();
        next({
          name: 'home_index'
        });
        } else {
            const curRouterObj = Util.getRouterObjByName([otherRouter, ...appRouter], to.name);
            if (curRouterObj && curRouterObj.access !== undefined) { // 需要判断权限的路由
                if (curRouterObj.access === parseInt(Cookies.get('access'))) {
                    Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
                } else {
                    next({
                        replace: true,
                        name: 'error-403'
                    });
                }
            } else { // 没有配置权限的路由, 直接通过
                Util.toDefaultPage([...routers], to.name, router, next);
            }
        }
    }
});

router.afterEach((to) => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js